import { Component, Input, Output, EventEmitter } from "@angular/core";
import { AppService } from "src/app/app.service";
import { TPR_LOG_ACTION_FEATURES, TPR_PAGE } from "src/app/tpr/tpr-constants";
@Component({
  selector: "app-tpr-document-modal",
  templateUrl: "./tpr-document-modal.component.html",
  styleUrls: ["./tpr-document-modal.component.scss"],
})
export class TprDocumentModalComponent {
  @Input() isModalOpen: boolean;
  @Input() companyId: number;
  @Input() sourceId: number;
  @Input() ticker: string;

  @Output() modalOpenStatus = new EventEmitter();

  researchCheckboxValue = true;
  modelCheckboxValue = true;
  filingCheckboxValue = true;
  primaryTickerValue = true;
  startDate = "";
  endDate = "";
  access: any = {
    has_filings_access: true,
    has_model_access: true,
    has_research_access: true,
  };

  constructor(private appService: AppService) {}

  closeModal() {
    this.modalOpenStatus.emit(false);
  }

  handleResearchCheckboxChange(value) {
    this.researchCheckboxValue = value;
    this.logCheckboxChange();
  }

  handleModelCheckboxChange(value) {
    this.modelCheckboxValue = value;
    this.logCheckboxChange();
  }

  handleFilingCheckboxChange(value) {
    this.filingCheckboxValue = value;
    this.logCheckboxChange();
  }

  handlePrimaryTickerChange(value) {
    this.primaryTickerValue = value;
    this.appService.logUserAction(
      {},
      this.ticker,
      "",
      TPR_LOG_ACTION_FEATURES.companyDocumentToggleChange,
      {
        primary_research: value,
      },
      "",
      TPR_PAGE,
    );
  }

  setAccess($event) {
    this.access = $event;
  }

  logCheckboxChange() {
    const documentTypes = [];
    if (this.researchCheckboxValue) {
      documentTypes.push("Research");
    }
    if (this.modelCheckboxValue) {
      documentTypes.push("Models");
    }
    if (this.filingCheckboxValue) {
      documentTypes.push("Filing");
    }
    this.appService.logUserAction(
      {},
      this.ticker,
      "",
      TPR_LOG_ACTION_FEATURES.companyDocumentTypeChange,
      {
        document_type: documentTypes,
      },
      "",
      TPR_PAGE,
    );
  }
}
